"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = require("react-dom");

var _canUseDom = _interopRequireDefault(require("./../_utils/can-use-dom"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// Shamelessly lifted from https://github.com/tajo/react-portal
var Portal = function Portal(props) {
  var defaultNode = (0, _react.useRef)();
  var children = props.children,
      node = props.node,
      onReachEndOfPortal = props.onReachEndOfPortal;
  (0, _react.useEffect)(function () {
    return function () {
      if (defaultNode.current) {
        document.body.removeChild(defaultNode.current);
      }

      defaultNode.current = null;
    };
  }, []); // If we can't use the DOM, don't even bother

  if (!_canUseDom["default"]) return null; // If we haven't been given a node to portal to and haven't yet
  // created a "default" node, create a new <div> element and append
  // it in the document's body

  if (!node && !defaultNode.current) {
    defaultNode.current = document.createElement("div");
    document.body.appendChild(defaultNode.current);
  } // Where we're portalling too


  var targetNode = node !== null && node !== void 0 ? node : defaultNode.current; // If we're not tracking when user reaches the "end" of the Portal, create a
  // simple Portal with the passed in children targeting the passed in node
  // or the defaultNode

  if (!onReachEndOfPortal) {
    return /*#__PURE__*/(0, _reactDom.createPortal)(children, targetNode);
  } // Else, create both a portal for the children _and_ a div that, when focused,
  // calls Portal's `onReachEndOfPortal` method
  else {
    return [/*#__PURE__*/(0, _reactDom.createPortal)(children, targetNode), /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react["default"].createElement("div", {
      tabIndex: "0",
      onFocus: onReachEndOfPortal
    }), targetNode)];
  }
};

Portal.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node.isRequired,
  node: _propTypes["default"].any,
  onReachEndOfPortal: _propTypes["default"].func
} : {};
var _default = Portal;
exports["default"] = _default;